import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const LOGOUT = 'AUTH/LOGOUT';

export const logoutActionSchema = objectSchemaOf<ILogoutAction>({
  type: Joi.string().required().valid(LOGOUT),
});

export interface ILogoutAction {
  type: typeof LOGOUT;
}

export const logout = actionCreator({
  type: LOGOUT,
  schema: logoutActionSchema,
});
